<script lang="ts">
    import type {GenericDatatypedFilterDefinition, NumberFilterableDatatype} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';
    import FilterButton from './FilterButton.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<NumberFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}>
    <svelte:fragment slot="filterButtons" let:value let:filterableDatatypeDefinition>
        <FilterButton {filterableDatatypeDefinition} {value} icon="less-than-equal" filterOperator="eqOrLess">
            Menší nebo rovno
        </FilterButton>

        <FilterButton {filterableDatatypeDefinition} {value} icon="greater-than-equal" filterOperator="eqOrMore">
            Větší nebo rovno
        </FilterButton>

        <FilterButton {filterableDatatypeDefinition} {value} icon="filter" defaultFilter>
            Rovno
        </FilterButton>
    </svelte:fragment>
</DatatypeValueEditor>